import React, {useEffect, useRef, useState} from "react";
import {useCaseListStore} from "./hooks/useCaseListStore";
import Filters from "./components/Filters/Filters";
import CaseTable from "./components/Table";
import {useLoaderData, useLocation, useNavigate} from "react-router-dom";
import {useQueryParams} from "../../../../../../hooks/useQueryParams";
import Search from "./components/Search";
import ItemCounter from "./components/TotalCount";
import Pagination from "./components/Pagination";
import {FilterListConfig} from "./components/FilterListConfig";
import Chips from "./components/Chips";
import {Divider, Typography} from "@mui/material";
import {ArrowForwardIos} from "@mui/icons-material";
import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import DashboardFilterProvider from "../../../DashboardVersions/GlobalUserDash/context/DashboardFilterContext";
import DashboardHeaderFilters from "../../../DashboardVersions/GlobalUserDash/DashboardHeaderFilters";
import parseFromQueryParamstoUIState from "./components/Filters/utils/parseFromQueryParamsToUIState";
import Svg, {SvgEnum} from "../../../../../ui library/components/svgs/standard/svg";

export default function CaseListList({
  customBaseDetailPath = "",
  customBaseDetailSegment = "",
}) {
  const navigate = useNavigate();

  const {cases, count, userStats,} = useLoaderData();
  const {filters, updateFilter, bulkUpdateFilters} = useQueryParams();
  const [filteredCases, setFilteredCases] = useState(cases);
  const state = useCaseListStore((state) => state);
  const [toggleFilterMenu, setToggleFilterMenu] = useState(false);
   const location = useLocation();
  const storageKey =
    customBaseDetailPath === "/client-detail/"
      ? "Dashboard"
      : "FinanceDashboard";
  
  useEffect(() => {
    updateFilter("limit", 100);
  }, []);

  useEffect(() => {
    setFilteredCases(cases);
    if (scrollRef.current) {
      scrollToTop();
    }
    saveCurrentFiltersToLocalStorage();
  }, [cases, filters]);


  useEffect(() => {
    let active = true;
    if (active) {
      if (!state.filterUI) {
        let newUI = {...FilterListConfig};

        let parsedUIObj = parseFromQueryParamstoUIState(filters, newUI);
        state.setFilterUI(parsedUIObj);
      }
    }
  }, [state.filterUI, filters]);
  const scrollRef = useRef(null);

  const scrollToTop = () => {
    scrollRef.current.scroll({
      top: 0,
    });
  };
  
  const saveCurrentFiltersToLocalStorage = () =>{
    let urlString = location.pathname + location.search;
    localStorage.setItem(storageKey, urlString);
  }

 
  return (
    <div id="Case-List_List" data-testid="Case-List-List">
      {userStats && cases && state.filterUI && (
        <DashboardFilterProvider>
          <DashboardHeaderFilters
            userStatData={userStats}
            medicalStatusData={userStats.medicalStatusCounts}
            filters={filters}
            updateFilter={updateFilter}
            getFilterUIState={state.filterUI}
            setFilterUIState={state}

          />
        </DashboardFilterProvider>
      )}

      <div className="h-full flex flex-row w-full bg-white max-h-[calc(100vh)] min-h-60 min-w-min" style={{
        position: 'relative',
        borderRadius: '6px',
        boxShadow: 'rgb(188, 209, 255) 3px 3px 10px 0px',
      }}>
        {toggleFilterMenu ? (
          <div
            className="flex flex-col w-[450px] h-full"
            style={{
              position: 'absolute',
              zIndex: '1000',
              backgroundColor: '#fff',
              borderRight: '1px solid #ececec',
              boxShadow: '4px 0 6px -2px rgba(0, 0, 0, 0.2)',
              borderRadius: '10px 0px 0px 10px'
            }}
          >
            <div className="flex flex-row justify-between items-center">
              <Typography className="text-lg font-bold p-2 pl-4">
                Filter Clients:
              </Typography>
              <CustomIconButton
                tooltipText="Hide Filter Menu"
                classes="rotate-180 p-2"
                handleOnClick={() => setToggleFilterMenu(!toggleFilterMenu)}
                iconVisible={true}
                CustomIcon={<ArrowForwardIos className="text-sky-600"/>}
              />
            </div>
            <Divider></Divider>
            {state.filterUI && (
              <Filters
                filters={filters}
                updateFilter={updateFilter}
                bulkUpdateFilters={bulkUpdateFilters}
              />
            )}
          </div>
        ) : ('')}

        <div className="flex-1 flex flex-col px-4">
          <div>
            <h2
              style={{
                fontSize: "24px",
                fontFamily: 'Roboto',
                marginTop: '25px',
                marginBottom: '15px',
              }}
            >
              Clients
            </h2>
          </div>
          <div className="mb-4 w-full flex justify-between">
            <div className="flex gap-2">
              <div>
                {state.filterUI && (
                  <Search
                    id={"search"}
                    filters={filters}
                    updateFilter={updateFilter}
                    setChipActive={state.setChipActive}
                    setActiveChipLabel={state.setActiveChipLabel}
                  />
                )}
              </div>
              <div className="flex">
                <button
                  style={{
                    backgroundColor: '#4C2AC6',
                    display: 'flex',
                    borderRadius: '35px',
                    padding: '9px 45px 9px 20px',
                    gap: '12px',
                    color: '#ffffff',
                    fontWeight: '500',
                    alignItems: 'center',
                  }}
                  onClick={() => setToggleFilterMenu(!toggleFilterMenu)}
                >
                  <Svg name={SvgEnum.HisFilters}/>
                  Filter Cases
                </button>
              </div>
            </div>
            <div>
              <button
                style={{
                  backgroundColor: '#D2CAF1',
                  border: '1px solid #4C2AC6',
                  color: '#4C2AC6',
                  display: 'flex',
                  borderRadius: '35px',
                  padding: '9px 45px 9px 20px',
                  gap: '12px',
                  fontWeight: '500',
                  alignItems: 'center',
                }}
                onClick={() => navigate('/add-client')}
              >
                <Svg name={SvgEnum.HisPlus}/>
                Add Client
              </button>
            </div>
          </div>
          <div className="mb-4 w-full flex flex-col">
            {state.filterUI && (
              <Chips filters={filters} bulkUpdateFilters={bulkUpdateFilters} />
            )}
          </div>
          <div className="h-full flex flex-col justify-between gap-4 overflow-hidden">
            <div className="w-full flex flex-row justify-between items-center">
              <ItemCounter
                filters={filters}
                actualNoOfRows={cases.length}
                count={count}
              />
            </div>
            <div className="flex-1 overflow-hidden min-h-[500px]">
              <CaseTable
                cases={filteredCases}
                filters={filters}
                updateFilter={updateFilter}
                customBaseDetailPath={customBaseDetailPath}
                customBaseDetailSegment={customBaseDetailSegment}
                referenceForScrolling={scrollRef}
              />
            </div>
            <div className="pt-2">
              <Pagination
                filters={filters}
                updateFilter={updateFilter}
                totalCount={count}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
